function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function pemToArrayBuffer(pem: string): ArrayBuffer {
  const b64 = pem
    .replace(/-----(BEGIN|END) PUBLIC KEY-----/g, "")
    .replace(/\s/g, "");
  return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0)).buffer;
}

async function importPublicKey(): Promise<CryptoKey> {
  const publicKeyPem = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyrDbH5PrHJvWKD93gSzV
  WyJyB5RY5UVPI7FQVFbe/amOlC7KaqBFpTKTXjK6/sn5nO4445N199cFqG+wUUiS
  wLooumwbjj4Lhl5jJNWDbbTht7ARPjkIXIcHpZcHFMaLPH6Yt6agffAoCNBS36WR
  i9a1rSwpGaor9T7Wwjr2nBpw7lsZFDVuCV6dtsDKfvtViR4TgoDbJDuouKffkwZI
  STo+Ho+x7pXY0o1Rv+8rzXgy2w12x8PMGPN7D6WGoIlhXIEmjBkiaNoMs+oUb8u+
  Sr4Hg0Q7UzT656gKgmxTKZGDq1f0fb1QPOCZat7VnY0r0Ar5k58VSMk5fcQz+a14
  8wIDAQAB
  -----END PUBLIC KEY-----`;

  const binaryDer = pemToArrayBuffer(publicKeyPem);
  return crypto.subtle.importKey(
    "spki",
    binaryDer,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );
}

export async function encryptPassword(password: string): Promise<string> {
  const publicKey = await importPublicKey();
  const encodedPassword = new TextEncoder().encode(password);
  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    publicKey,
    encodedPassword
  );
  return arrayBufferToBase64(encryptedBuffer);
}
